import { render, staticRenderFns } from "./TipsGameMobile.vue?vue&type=template&id=a3d0e52e&scoped=true&"
import script from "./TipsGameMobile.vue?vue&type=script&lang=js&"
export * from "./TipsGameMobile.vue?vue&type=script&lang=js&"
import style0 from "./TipsGameMobile.vue?vue&type=style&index=0&id=a3d0e52e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3d0e52e",
  null
  
)

export default component.exports